import { Thunk, thunk, Action, action } from 'easy-peasy'
import api from '../api'
import { UserModel } from '../components/RateSet/Form/types/user'

export interface UsersModel {
  users: UserModel[]
  setUsers: Action<UsersModel, UserModel[]>
  fetchUsers: Thunk<UsersModel>
}

const usersModel: UsersModel = {
  // State
  users: [],

  // actions
  setUsers: action((state, payload) => {
    state.users = payload
  }),

  // thunks
  fetchUsers: thunk(async actions => {
    try {
      const { data } = await api.users.getAll()
      const users = data.map(user => {
        return {
          user_id: user.user_id,
          name: user.name
        }
      })
      actions.setUsers(users)
    } catch (e) {
      console.error(e)
    }
  })
}

export default usersModel
